/* eslint-disable @typescript-eslint/no-magic-numbers */
import React from 'react';
import { useForm } from 'react-hook-form';
import loadable from '@loadable/component';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { AppFormProvider } from '@cp/utils/form';
import { CatalogNavVacancyFormModel } from '../model';
import { getDefaultValues } from '../model/utils/getDefaultValues';
import { WatcherProps } from '../model/watcher.interface';
import { Watcher } from '../model/watcher';
import { CatalogNavVacancyProps, CatalogNavVacancyViewProps } from './model';

const ViewDesktop = loadable(() => import('./view.desktop'));
const ViewMobile = loadable(() => import('./view.mobile'));

export const CatalogNavVacancy: React.FC<CatalogNavVacancyProps> = ({
  careerId,
  sx,
  onChangeCity,
  onMapButtonClick,
  defaultCity,
  careerDictionary,
}) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(MOBILE_BREAKPOINT_THRESHOLD));
  const defaultValues = React.useMemo(() => getDefaultValues(defaultCity), [defaultCity]);

  const form = useForm<CatalogNavVacancyFormModel>({
    defaultValues: {
      ...defaultValues,
    },
  });

  const watcherProps: WatcherProps = { defaultCity, form, onChangeCity, defaultValues };

  const viewProps: CatalogNavVacancyViewProps = {
    careerId,
    form,
    onMapButtonClick,
    sx,
    careerDictionary,
  };

  const View = isMobileScreen ? ViewMobile : ViewDesktop;

  return (
    <AppFormProvider form={form}>
      <Watcher {...watcherProps} />
      <View {...viewProps} />
    </AppFormProvider>
  );
};
